// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file monitoreo_broca.proto (package sextante.monitoreo.broca.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file monitoreo_broca.proto.
 */
export const file_monitoreo_broca: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Monitoreo de broca de un lote en una fecha.
 *
 * @generated from message sextante.monitoreo.broca.v1.MonitoreoBrocaItem
 */
export type MonitoreoBrocaItem = Message<"sextante.monitoreo.broca.v1.MonitoreoBrocaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: string lote_id = 5;
   */
  loteId: string;

  /**
   * @generated from field: string lote_nombre = 6;
   */
  loteNombre: string;

  /**
   * yyyy-MM-dd (DateOnly)
   *
   * @generated from field: string fecha = 7;
   */
  fecha: string;

  /**
   * @generated from field: int32 anio = 8;
   */
  anio: number;

  /**
   * Semana del anio de la fecha del monitoreo.
   *
   * @generated from field: int32 semana_del_anio = 9;
   */
  semanaDelAnio: number;

  /**
   * @generated from field: int32 arboles_evaluados = 10;
   */
  arbolesEvaluados: number;

  /**
   * @generated from field: int32 arboles_brocados = 11;
   */
  arbolesBrocados: number;

  /**
   * @generated from field: int32 frutos_evaluados = 12;
   */
  frutosEvaluados: number;

  /**
   * @generated from field: int32 frutos_brocados = 13;
   */
  frutosBrocados: number;

  /**
   * @generated from field: int32 posicion1 = 14;
   */
  posicion1: number;

  /**
   * @generated from field: int32 posicion2 = 15;
   */
  posicion2: number;

  /**
   * @generated from field: int32 ausentes = 16;
   */
  ausentes: number;

  /**
   * @generated from field: int32 muertas = 17;
   */
  muertas: number;

  /**
   * @generated from field: double infestacion_real = 18;
   */
  infestacionReal: number;

  /**
   * "low" | "mid" | "high"
   *
   * @generated from field: string infestacion_real_color = 19;
   */
  infestacionRealColor: string;

  /**
   * @generated from field: double mortalidad = 20;
   */
  mortalidad: number;

  /**
   * "low" | "mid" | "high"
   *
   * @generated from field: string mortalidad_color = 21;
   */
  mortalidadColor: string;
};

/**
 * Describes the message sextante.monitoreo.broca.v1.MonitoreoBrocaItem.
 * Use `create(MonitoreoBrocaItemSchema)` to create a new message.
 */
export const MonitoreoBrocaItemSchema: GenMessage<MonitoreoBrocaItem> = /*@__PURE__*/
  messageDesc(file_monitoreo_broca, 0);

/**
 * Pedido de los monitoreos de broca de una finca.
 *
 * @generated from message sextante.monitoreo.broca.v1.ListMonitoreoBrocaByFincaIdRequest
 */
export type ListMonitoreoBrocaByFincaIdRequest = Message<"sextante.monitoreo.broca.v1.ListMonitoreoBrocaByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.monitoreo.broca.v1.ListMonitoreoBrocaByFincaIdRequest.
 * Use `create(ListMonitoreoBrocaByFincaIdRequestSchema)` to create a new message.
 */
export const ListMonitoreoBrocaByFincaIdRequestSchema: GenMessage<ListMonitoreoBrocaByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_monitoreo_broca, 1);

/**
 * Monitoreos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.monitoreo.broca.v1.ListMonitoreoBrocaByFincaIdResponse
 */
export type ListMonitoreoBrocaByFincaIdResponse = Message<"sextante.monitoreo.broca.v1.ListMonitoreoBrocaByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.monitoreo.broca.v1.MonitoreoBrocaItem items = 1;
   */
  items: MonitoreoBrocaItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.monitoreo.broca.v1.ListMonitoreoBrocaByFincaIdResponse.
 * Use `create(ListMonitoreoBrocaByFincaIdResponseSchema)` to create a new message.
 */
export const ListMonitoreoBrocaByFincaIdResponseSchema: GenMessage<ListMonitoreoBrocaByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_monitoreo_broca, 2);

/**
 * A diferencia del Item, el request de guardado SI lleva los campos "calculados" completos: el
 * server los persiste tal cual, sin recalcularlos (ver MonitoreoBrocaRequest.cs) — recortarlos acá
 * corrompería el dato guardado, no es lo mismo que recortar un campo de solo lectura que nadie lee.
 *
 * @generated from message sextante.monitoreo.broca.v1.GuardarMonitoreoBrocaRequest
 */
export type GuardarMonitoreoBrocaRequest = Message<"sextante.monitoreo.broca.v1.GuardarMonitoreoBrocaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string lote_id = 2;
   */
  loteId: string;

  /**
   * yyyy-MM-dd (DateOnly)
   *
   * @generated from field: string fecha = 3;
   */
  fecha: string;

  /**
   * @generated from field: int32 arboles_evaluados = 4;
   */
  arbolesEvaluados: number;

  /**
   * @generated from field: int32 arboles_brocados = 5;
   */
  arbolesBrocados: number;

  /**
   * @generated from field: int32 frutos_evaluados = 6;
   */
  frutosEvaluados: number;

  /**
   * OBSOLETO (2026-10-28): lo calcula el servidor y este valor se ignora.
   *
   * @generated from field: int32 arboles_limpios = 7;
   */
  arbolesLimpios: number;

  /**
   * @generated from field: int32 frutos_brocados = 8;
   */
  frutosBrocados: number;

  /**
   * @generated from field: int32 posicion1 = 9;
   */
  posicion1: number;

  /**
   * @generated from field: int32 posicion2 = 10;
   */
  posicion2: number;

  /**
   * @generated from field: int32 ausentes = 11;
   */
  ausentes: number;

  /**
   * @generated from field: int32 muertas = 12;
   */
  muertas: number;

  /**
   * OBSOLETOS (2026-10-28): los diez derivados los calcula el servidor con
   * `CalculoBroca` y estos valores se ignoran. Siguen en el mensaje para no
   * romper el cliente generado de la web; se pueden quitar cuando el formulario
   * deje de enviarlos.
   *
   * @generated from field: int32 totales = 13;
   */
  totales: number;

  /**
   * @generated from field: double porcentaje_posicion1 = 14;
   */
  porcentajePosicion1: number;

  /**
   * @generated from field: double porcentaje_posicion2 = 15;
   */
  porcentajePosicion2: number;

  /**
   * @generated from field: double porcentaje_ausentes = 16;
   */
  porcentajeAusentes: number;

  /**
   * @generated from field: double porcentaje_muertas = 17;
   */
  porcentajeMuertas: number;

  /**
   * @generated from field: double promedio_granos_x_rama = 18;
   */
  promedioGranosXRama: number;

  /**
   * @generated from field: double infestacion_general = 19;
   */
  infestacionGeneral: number;

  /**
   * @generated from field: double infestacion_real = 20;
   */
  infestacionReal: number;

  /**
   * @generated from field: double mortalidad = 21;
   */
  mortalidad: number;
};

/**
 * Describes the message sextante.monitoreo.broca.v1.GuardarMonitoreoBrocaRequest.
 * Use `create(GuardarMonitoreoBrocaRequestSchema)` to create a new message.
 */
export const GuardarMonitoreoBrocaRequestSchema: GenMessage<GuardarMonitoreoBrocaRequest> = /*@__PURE__*/
  messageDesc(file_monitoreo_broca, 3);

/**
 * Monitoreos de broca del cafe de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja de
 * servicios. Solo listado y guardado: el modulo no tiene baja. Requiere sesion de la app Cliente.
 * 
 * Nombres de mensaje con prefijo de dominio: ver terceros_lote.proto para el gotcha real del
 * csharp_namespace compartido — revisar que un nombre no exista ya en otro .proto antes de usarlo.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.monitoreo.broca.v1.MonitoreoBrocaService
 */
export const MonitoreoBrocaService: GenService<{
  /**
   * Monitoreos de broca de una finca, por delta.
   *
   * @generated from rpc sextante.monitoreo.broca.v1.MonitoreoBrocaService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListMonitoreoBrocaByFincaIdRequestSchema;
    output: typeof ListMonitoreoBrocaByFincaIdResponseSchema;
  },
  /**
   * Crea el monitoreo si no viene id, o lo actualiza si viene. La finca sale del lote.
   *
   * @generated from rpc sextante.monitoreo.broca.v1.MonitoreoBrocaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarMonitoreoBrocaRequestSchema;
    output: typeof MonitoreoBrocaItemSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_monitoreo_broca, 0);

